<template>
  <div class="d-flex thick-border px-2 min py-1" :class="[border, textColor, `background-${type}`]">
    <i class="" />
    <span v-html="$t(messageId, fillInData)"></span>
  </div>
</template>

<script>
export default {
  computed: {
    textColor () {
      switch (this.type) {
        case 'information':
          return `text-info`
      }
      return 'text-secondary'
    },
    border () {
      return 'border-left border-info'
    }
  },
  props: {
    type: {
      type: String,
      default: 'information'
    },
    messageId: {
      type: String,
      default: ''
    },
    fillInData: {
      type: Array,
      default: () => []
    }
  }
}
</script>
<style>
.thick-border {
  border-width: thick !important;
}

.background-information {
  background-color: #17a2b817
}
</style>